function getNow(type) {
    let date = new Date();
    var yyyy = date.getFullYear();
    var mm = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var dd = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var HH = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
    var MM = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
    var SS = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
    switch (type) {
        case 'yyyymmdd':{
            return yyyy + '' + mm + '' + dd
        }
        case 'yyyy-mm-dd':{
            return yyyy + '-' + mm + '-' + dd
        }
        case 'yyyy年mm月dd日':{
            return yyyy + '年' + mm + '月' + dd + '日'
        }
        default :{
            return yyyy + '' + mm + '' + dd
        }
    }
}
function getWeek(date,type) {
    const arr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    let week = null;
    if (type == undefined){
        week = new Date(date).getDay();
    }
    if (type == 'yyyymmdd'){
        let dateFormat = date.substring(0,4) + '/' + date.substring(4,6) + '/' + date.substring(6,8);
            console.log('test',dateFormat)
        week = new Date(dateFormat).getDay();
    }

    return arr[week];
}
function numAnimation(targetEle, options) {
    options = options || {};

    var $this = document.getElementById(targetEle);
    var time = options.time;
    var finalNum = options.num;
    var regulator = options.regulator || 100, //调速器，改变regulator的数值可以调节数字改变的速度

        step = finalNum / (time / regulator),/*每30ms增加的数值--*/
        count = options.start, //计数器
        initial = 0;

    var timer = setInterval(function () {

        count = count + step;

        if (count >= finalNum) {
            clearInterval(timer);
            count = finalNum;
        }

        var t = Math.floor(count);
        if (t == initial) return;

        initial = t;

        if ($this) {
            $this.innerHTML = initial;
        }
    }, 30);
}

export {
    getNow, getWeek, numAnimation
}
